// extracted by mini-css-extract-plugin
module.exports = {"table":"tenantInfoDialog_table__9VG8I","tips":"tenantInfoDialog_tips__3JuAu"};